import React from 'react'

const BookContainer = () => {
  return (
    <div>BookContainer</div>
  )
}

export default BookContainer